import type { MaquetaPortada, PublicAd, PublicPortadaSlot } from '@ahora-patagonia/contracts';
import { PortadaA } from './PortadaA.js';
import { PortadaB } from './PortadaB.js';
import { PortadaC } from './PortadaC.js';
import type { PartePortada } from './portadaPartes.js';

export interface PortadaProps {
  slots: PublicPortadaSlot[];
  /** Con cuál de las tres maquetas la dibuja la redacción (ver `maqueta-portada.ts`). */
  maqueta: MaquetaPortada;
  /** Qué mitad del bloque se dibuja acá. Ver `portadaPartes.ts`. */
  parte?: PartePortada;
  /** El "pie de portada" (≥1200): solo existe en A. Sin campaña, nada. */
  adPieDePortada: PublicAd | undefined;
}

/**
 * La portada: el bloque que abre la página principal.
 *
 * Es lo **único** del sitio que la redacción cura nota por nota, y desde ahora también elige cómo
 * se ve: A la de siempre, B una nota que se lleva el frente entero, C dos que se lo disputan. La
 * maqueta viaja en el bloque, así que acá no hay más que despachar —agregar una cuarta es agregar
 * un archivo, no tocar la home.
 *
 * Los slots que llegan son **los que la maqueta dibuja**: el recorte lo hizo el servidor. Los
 * huecos siguen siendo huecos —un slot sin nota deja su celda vacía y no se autocompleta.
 */
export function Portada({ slots, maqueta, parte = 'completa', adPieDePortada }: PortadaProps) {
  if (maqueta === 'B') {
    // B no tiene resto: debajo de la nota única no va más portada.
    if (parte === 'resto') return null;
    return <PortadaB slots={slots} />;
  }

  if (maqueta === 'C') return <PortadaC slots={slots} parte={parte} />;

  // A se dibuja entera siempre: su frente vive dentro de la columna principal, así que nunca se
  // parte en dos.
  return <PortadaA slots={slots} adPieDePortada={adPieDePortada} />;
}
